import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import QrReader from 'react-qr-reader';
import { ToastContainer, toast, Slide } from 'react-toastify';
import ToastHandler from '../../components/toasthandler';
import AddressSelect from '../../components/addressselect';

import {
  fetchSecurity,
  withdrawFunds,
  fetchWithdrawalFees,
  fetchAddresses,
} from '../../actions';

class WithdrawModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmStage: 1,
      useNickname: '',
      useTag: '',
      useAddress: '',
      quantity: '',
      note: '',
      otp: '',
      showQr: false,
      pristine: true,
      useDropdown: false,
      manualYubiKey: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.confirmWithdraw = this.confirmWithdraw.bind(this);
    this.modalSide = this.modalSide.bind(this);
    this.handleScan = this.handleScan.bind(this);
    this.addressChange = this.addressChange.bind(this);
    this.clearAddress = this.clearAddress.bind(this);
    this.toggleYubikeyListener = this.toggleYubikeyListener.bind(this);
    this.captureYubiKey = this.captureYubiKey.bind(this);
    this.editWithdrawal = this.editWithdrawal.bind(this);
    this.toggleYubiKeyManual = this.toggleYubiKeyManual.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const numInputs = document.querySelectorAll('input[type="number"]');
    numInputs.forEach(function(elem) {
      elem.addEventListener('keypress', function (e) {
        if (e.keyCode === 8 || e.key === '.') { return }
        if (e.keyCode < 48 || e.keyCode > 57)
        { e.preventDefault(); }
      });
    });
    dispatch(fetchSecurity());
    dispatch(fetchAddresses());
  }

  componentWillUnmount() {
    const numInputs = document.querySelectorAll('input[type="number"]');
    numInputs.forEach(function(elem) {
      elem.removeEventListener('keypress', function (e) {
        if (e.keyCode === 8 || e.key === '.') { return }
        if (e.keyCode < 48 || e.keyCode > 57)
        { e.preventDefault(); }
      });
    });
    this.toggleYubikeyListener('DISABLE');
  }

  toggleYubikeyListener(type) {
    if (type === 'ENABLE') {
      document.addEventListener('keypress', this.captureYubiKey, false);
    }
    if (type === 'DISABLE') {
      document.removeEventListener('keypress', this.captureYubiKey, false);
    }
  }

  toggleYubiKeyManual() {
    const { manualYubiKey } = this.state;
    if (!manualYubiKey) {
      this.toggleYubikeyListener('DISABLE');
    } else {
      this.toggleYubikeyListener('ENABLE');
    }
    this.setState({manualYubiKey: !manualYubiKey, otp: ''})
  }

  captureYubiKey(e) {
    const { user } = this.props;
    const { otp } = this.state;
    if (e.which === 13 || e.key === 'Enter') {
      this.confirmWithdraw(e);
      return;
    }
    let useYubikey = '' + e.key;
    if (otp) {
      useYubikey = otp + e.key;
    }
    this.setState({otp: useYubikey});
  }

  handleScan(data) {
    if (data) {
      toast.success(
        <div>
          <div className="toast-icon">
            <img alt="success" src={ process.env.REACT_APP_CDN + '/assets/icons/tick.svg'} />
          </div>
          <div className="toast-info">
            QR Scan Successful
          </div>
        </div>,
      );
      this.setState({
        useAddress: data,
        showQr: false,
      });
    }
  }

  handleError(err) {
    console.error(err);
  }

  handleSubmit(event) {
    event.preventDefault();
    const { user, dispatch, asset, assetNet, sendDefaults } = this.props;
    const { quantity, note } = this.state;

    let yubiEnabled;

    if (user.security) {
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    const data = {
      asset,
      quantity,
    };

    let minLimit;

    if (sendDefaults && sendDefaults.min) {
      minLimit = sendDefaults.min;
    }

    let error = [];

    if (Number(quantity) > assetNet) {
      error = ['Amount entered exceeds your available balance'];
    } else if (assetNet < minLimit) {
      error = ['Insuffient amount'];
    }

    if (assetNet >= minLimit && Number(quantity) <= assetNet) {
      dispatch(fetchWithdrawalFees(data))
        .then((res) => {
          if (res.type === 'FETCH_WITHDRAWAL_FEES_SUCCESS') {
            this.setState({ confirmStage: 2, errors: null });
            if (yubiEnabled) {
              this.toggleYubikeyListener('ENABLE');
            }
          }
        });
    }

    if (error.length > 0) {
      this.setState((prev) => ({ ...prev, errors: { error } }))
    }
  }

  confirmWithdraw(event) {
    event.preventDefault();
    const { dispatch, asset, erc20 } = this.props;
    const { useAddress, quantity, otp, note } = this.state;

    let address = useAddress;
    if (erc20) {
      if (useAddress && !useAddress.startsWith('0x')) {
        address = '0x' + useAddress;
      }
    }
    const data = {
      asset,
      otp,
      address,
      notes: note,
      quantity,
    };

    this.setState({ pristine: true });

    dispatch(withdrawFunds(data))
      .then((res) => {
        if (res.type === 'WITHDRAW_FUNDS_SUCCESS') {
          this.setState({
            // newLabel: '',
            useAddress: '',
            quantity: '',
            otp: '',
            confirmStage: 3,
          });
          this.clearAddress();
          this.toggleYubikeyListener('DISABLE');
        }
      });
  }

  handleChange(event) {
    const { asset, erc20 } = this.props;
    let value;
    if (event.target.value) {
      value = event.target.value;
    }
    if (value) {
      if (erc20) {
        if (asset === 'ETH') {
          if ((event.target.id === 'useAddress') && (value)) {
            if (value.startsWith('ethereum:0x')) {
              value = event.target.value.slice(11);
            }
            if (value.startsWith('ethereum:')) {
              value = event.target.value.slice(9);
            }
          }
        }
        if (value.startsWith('0x')) {
          value = event.target.value.substring(2);
        }
      }
    }
    this.setState({ [event.target.id]: value, pristine: false });
  }

  modalSide() {
    const { asset, humAsset, urlAsset, assetPending, assetSettled, assetNet } = this.props;
    const sideBG = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/images/modal-shape.png'})`,
    };
    return (
      <div className="modal-side">
        <div className="modal-close" onClick={() => this.props.toggleModal(null)}>
          <img alt="close" src={ process.env.REACT_APP_CDN + '/assets/icons/close-w.svg'} />
        </div>
        <div style={sideBG} className="ms-content">
          <div className="ms-head">
            <div className={'card-coin ' + urlAsset.toLowerCase()}>
              <img alt={humAsset} src={ process.env.REACT_APP_CDN + '/assets/icons/assets/' + urlAsset.toLowerCase() + '.svg'} />
            </div>
            <div className="ms-head-title">
              {asset} Account
            </div>
          </div>
          <div className="ms-table">
            <div className="mst-row">
              <div>Settled Balance</div>
              <div className="num">
                {assetSettled} {asset}
              </div>
            </div>
            <div className="mst-row">
              <div>Blocked Balance</div>
              <div className="num">
                {assetPending} {asset}
              </div>
            </div>
            <div className="mst-row">
              <div>Available Balance</div>
              <div className="num">
                {assetNet} {asset}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  addressChange(data) {
    let id;
    let address;
    let nickname;
    let tag;
    let typeHandle;
    let referenceId;
    if (data.id) {
      id = data.id
    }
    if (data.item) {
      if (data.item.address) {
        address = data.item.address;
      }
      if (data.item.nickname) {
        nickname = data.item.nickname;
      }
      if (data.item.referenceId) {
        referenceId = data.item.referenceId;
      }
      if (data.item.tag) {
        tag = data.item.tag;
      }
      if (data.item.typeHandle) {
        typeHandle = data.item.typeHandle;
      }
    }
    this.setState({
      useNickname: nickname,
      useTag: tag,
      useAddress: address,
      useDropdown: true,
    })
  }

  clearAddress() {
    this.setState({
      useNickname: '',
      useTag: '',
      useAddress: '',
      useDropdown: false,
    })
  }

  editWithdrawal() {
    this.setState({ confirmStage: 1, otp: '' });
  }

  render() {
    const { user, errors, success, asset, humAsset, urlAsset, assetNet, decimal, withdrawFee, sendDefaults, receiveDefaults, assetConf, erc20, addressbook } = this.props;
    const { useAddress, quantity, otp, confirmStage, showQr, pristine, useDropdown, manualYubiKey, note } = this.state;

    let transFee = 0;
    let transNet = 0;
    let transMin = 0;
    let transDaily = 0;
    let transPattern;
    let transPatternTitle;

    if (assetConf && assetConf.transfers) {
      if (assetConf.transfers.regex) {
        transPattern = assetConf.transfers.regex;
      }
      if (assetConf.transfers.limitText) {
        transPatternTitle = assetConf.transfers.limitText;
      }
    }

    if (sendDefaults) {
      if (sendDefaults.fee) {
        transFee = sendDefaults.fee;
      }
      if (sendDefaults.min) {
        transMin = sendDefaults.min;
      }

      // stop the plebs from withdrawing tiny sums
      if (assetConf.handle === 'TST' && assetNet > transMin) {
        transMin = assetNet - 1;
      }

      if (sendDefaults.max) {
        transDaily = sendDefaults.max;
      }
    }

    if ((transFee >= 0 ) && quantity) {
      transNet = Number(quantity) - transFee;
    }

    const complete = (assetNet > 0) && useAddress && quantity && transNet && transMin && (quantity > 0) && (quantity >= transMin);

    const confirmReady = (assetNet > 0) && useAddress && quantity && otp && transNet && transMin && (quantity > 0) && (quantity >= transMin) && !pristine;

    const firstStageErrors = this.state.errors || errors;

    let withGross;
    let withFee;
    let withNet;
    if (withdrawFee) {
      if (withdrawFee.gross) {
        withGross = Number(withdrawFee.gross);
      }
      if (withdrawFee.fee) {
        withFee = Number(withdrawFee.fee);
      }
      if (withdrawFee.net) {
        withNet = Number(withdrawFee.net);
      }
    }

    let underMinimum;
    let overMaximum;
    if (transMin && (quantity > 0)) {
      underMinimum = Number(quantity) < Number(transMin);
    }
    if (assetNet && (quantity > 0)) {
      overMaximum = Number(quantity) > Number(assetNet);
    }

    let addressbookData;
    if (addressbook && addressbook.data && addressbook.data.length) {
      addressbookData = addressbook.data;
    }

    const whitelistEnabled = user && user.me && user.me.flags && user.me.flags.addressbookWhitelist;

    let otpEnabled;
    let yubiEnabled;

    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    const needsConfirmation = success && success.needsConfirmation;

    if (confirmStage === 2) {
      return (
        <form className="withdep" onSubmit={this.confirmWithdraw} id="withdrawConfirm">
          <ToastHandler errors={errors} success={success} />
          <div className="grid-x modal-main">
            <div className="modal-title">
              <div className={'card-coin ' + urlAsset.toLowerCase()}>
                <img alt={humAsset} src={ process.env.REACT_APP_CDN + '/assets/icons/assets/' + urlAsset.toLowerCase() + '.svg'} />
              </div>
              <span>
                {asset} Account
              </span>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Withdrawal from Vaultoro</div>
            </div>

            <div className="cell small-12 medium-12 large-12 modal-form">
              <div className="grid-x align-middle group">
                <div className="cell small-12 medium-6 large-4">
                  <div className="gf-label">
                    <span style={{ textTransform: 'uppercase' }}>{asset} </span>
                    Withdrawal address
                  </div>
                </div>
                <div className="cell small-12 medium-6 large-8">
                  <div className="gf-info">
                    {useAddress}
                    {/* {erc20 ? (
                      '0x' + useAddress
                    ) : (
                      useAddress
                    )} */}
                  </div>
                </div>
              </div>
              <div className="grid-x align-middle group">
                <div className="cell small-12 medium-6 large-4">
                  <div className="gf-label">
                    Amount
                  </div>
                </div>
                <div className="cell small-12 medium-6 large-8">
                  <div className="gf-info num">
                    {withGross ? (
                      Number(withGross).toFixed(decimal)
                    ) : (
                      Number(0).toFixed(decimal)
                    )}
                    &nbsp;
                    {asset}
                  </div>
                </div>
              </div>
              <div className="grid-x align-middle group">
                <div className="cell small-12 medium-6 large-4">
                  <div className="gf-label">
                    Fee
                  </div>
                </div>
                <div className="cell small-12 medium-6 large-8">
                  <div className="gf-info num">
                    {withFee ? (
                      Number(withFee).toFixed(decimal)
                    ) : (
                      Number(0).toFixed(decimal)
                    )}
                    &nbsp;
                    {asset}
                  </div>
                </div>
              </div>
              <div className="grid-x align-middle group">
                <div className="cell small-12 medium-6 large-4">
                  <div className="gf-label">
                    You will receive
                  </div>
                </div>
                <div className="cell small-12 medium-6 large-4">
                  <div className="gf-info num">
                    {withNet ? (
                      Number(withNet).toFixed(decimal)
                    ) : (
                      Number(0).toFixed(decimal)
                    )}
                    &nbsp;
                    {asset}
                  </div>
                </div>
              </div>
              { note ? (
                <div className="grid-x align-middle group" style={{height: 'unset'}}>
                  <div className="cell small-12 medium-6 large-4">
                    <div className="gf-label">
                      Your note
                    </div>
                  </div>
                  <div className="cell small-12 medium-6 large-8">
                    <div className="gf-info">
                      {note}
                    </div>
                  </div>
                </div>
              ) : (null)}
              {otpEnabled ? (
                <div className="text-center">
                  <p>
                    <b>
                      Two-Factor Auth Code
                    </b>
                  </p>
                  <input className="modal-input" type="text" name="otp" placeholder="Two-Factor Auth"  autoComplete="off" id="otp" value={otp} onChange={this.handleChange} />
                  <div style={{ marginTop: 16 }} className="button-area">
                    <button type="button" onClick={() => this.editWithdrawal()} className="button"><span>No, Edit Withdrawal</span></button>
                    <button type="submit" className="vlt-button vlt-green" disabled={!confirmReady}><span>Yes, Confirm Withdrawal</span></button>
                  </div>
                </div>
              ) : null }
              {yubiEnabled ? (
                <div className="text-center">
                  <div>
                    <h2>
                      YubiKey Auth
                    </h2>
                    <p>
                      1. Insert your YubiKey into a USB port
                      <br />
                      {manualYubiKey ? (
                        '2. Enter your YubiKey code in the field below'
                      ) : (
                        '2. Touch the YubiKey button'
                      )}
                    </p>
                  </div>
                  <div>
                    <div>
                      <img alt="YubiKeys" src={ process.env.REACT_APP_CDN + '/assets/images/yubikeys.png'} style={{maxWidth: '80%', marginBottom: '20px'}}/>
                    </div>
                    {manualYubiKey ? (
                      <div>
                        <input id="otp" className="modal-input" type="password" name="otp" placeholder="Enter YubiKey" value={otp} autoComplete="off" onChange={this.handleChange} autoFocus />
                      </div>
                    ) : null}
                    <div style={{ marginTop: 16 }} className="button-area">
                      <button type="button" onClick={() => this.editWithdrawal()} className="button"><span>No, Edit Withdrawal</span></button>
                      {manualYubiKey ? (
                        <button type="submit" className="vlt-button vlt-green" disabled={!confirmReady}><span>Yes, Confirm Withdrawal</span></button>
                      ) : (
                        <button className="button" type="submit" onClick={this.toggleYubiKeyManual}>
                          <span>
                            Yes, Submit YubiKey Manually
                          </span>
                        </button>
                      ) }
                    </div>
                  </div>
                </div>
              ) : null }
            </div>
            <div className="cell small-12 medium-12 large-12 wd-info">
              <p className="wdi-head">
                You can only withdraw once every 5 minutes
              </p>
              <p>
                Do not withdraw directly to a crowdfund or ICO. We will not credit your account with tokens from that sale.
              </p>
            </div>

          </div>
          {this.modalSide()}
        </form>
      );
    }

    if (confirmStage === 3) {
      return (
        <form className="withdep" onSubmit={this.confirmWithdraw} id="withdrawConfirm" autoComplete="off">
          <ToastHandler errors={errors} success={success} />
          <div className="grid-x modal-main">
            <div className="modal-title">
              <div className={'card-coin ' + urlAsset.toLowerCase()}>
                <img alt={humAsset} src={ process.env.REACT_APP_CDN + '/assets/icons/assets/' + urlAsset.toLowerCase() + '.svg'} />
              </div>
              <span>
                {asset} Account
              </span>
            </div>
            {needsConfirmation ? (
              <>
                <div className="cell small-12 medium-12 large-12">
                  <div className="modal-heading">Confirmation Required</div>
                </div>
                <div className="cell small-12 medium-12 large-12 modal-form" style={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    style={{
                      fontSize: 100,
                      color: 'rgb(59, 197, 128)',
                    }}
                    icon={faEnvelope}
                  />
                  <div>
                    <p>
                      You have been sent an email with a link to confirm this withdrawal. It will be held until then.
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="cell small-12 medium-12 large-12">
                  <div className="modal-heading">Withdrawal Submitted</div>
                </div>
                <div className="cell small-12 medium-12 large-12 modal-form" style={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    style={{
                      fontSize: 100,
                      color: 'rgb(59, 197, 128)',
                    }}
                    icon={faCheckCircle}
                  />
                  <p>
                    You can track it&apos;s progress via the history page.
                  </p>
                  <div>
                    <h3 style={{ marginBottom: '0px' }}>Please Note:</h3>
                    <p style={{ margin: '8px 0px' }}>
                      The transaction may still be refused or cancelled.
                    </p>
                  </div>
                </div>
              </>
            )}
            <div className="cell small-12 medium-12 large-12 modal-form">
              {needsConfirmation ? (
                <div style={{ marginTop: 16 }} className="text-center">
                  <button type="button" onClick={() => this.setState({ confirmStage: 1 })} className="vlt-button"><span>I understand</span></button>
                </div>
              ) : (
                <div style={{ marginTop: 16 }} className="button-area">
                  <button type="button" onClick={() => this.setState({ confirmStage: 1 })} className="button"><span>Let&apos;s do another</span></button>
                  <a href="/history" className="vlt-button" disabled={!confirmReady}><span>History</span></a>
                </div>
              )}
            </div>
          </div>
          {this.modalSide()}
        </form>
      );
    }

    return (
      <form className="withdep" onSubmit={this.handleSubmit} id="withdrawForm" autoComplete="off">
        <ToastHandler errors={firstStageErrors} success={success} />
        <div className="grid-x modal-main">
          <div className="modal-title">
            <div className={'card-coin ' + urlAsset.toLowerCase()}>
              <img alt={humAsset} src={ process.env.REACT_APP_CDN + '/assets/icons/assets/' + urlAsset.toLowerCase() + '.svg'} />
            </div>
            <span>
              {asset} Account
            </span>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-heading">Withdrawal from Vaultoro</div>
          </div>

          {showQr && (
            <div className="qr-scan-con">
              <QrReader
                delay={this.state.delay}
                onError={this.handleError}
                onScan={this.handleScan}
                className="qr-scanner"
              />
            </div>
          )}

          <div className="cell small-12 medium-12 large-12 modal-form">
            <p>
              <span style={{ textTransform: 'uppercase' }}>{asset} </span>
              Withdrawal address
            </p>
            <div className="input-btn-modal">
              <div className={erc20 ? 'input-wrapper erc20' : 'input-wrapper'}>
                <AddressSelect
                  onDropChange={this.addressChange}
                  onInputChange={this.handleChange}
                  curVal={useAddress || ''}
                  options={addressbookData || []}
                  optName="nickname"
                  optVal="address"
                  useId="address"
                  assetType={asset}
                  clearAddress={this.clearAddress}
                  useDropdown={useDropdown}
                  erc20={erc20}
                  pattern={transPattern}
                  title={transPatternTitle}
                  whitelistEnabled={whitelistEnabled}
                />
              </div>
              <button type="button" className="vlt-button white-b" onClick={() => this.setState({ showQr: !showQr })}>
                <span>
                  Scan QR
                </span>
              </button>
            </div>
            <p>
              Amount
            </p>
            <input className="modal-input" type="number" name="quantity" placeholder="Quantity" id="quantity" value={quantity} onChange={this.handleChange} min="0" step="0.00000001" />
            <p>
              Note <span className="mute">(Optional)</span>
            </p>
            <input className="modal-input" type="text" name="note" placeholder="Note" id="note" value={note} onChange={this.handleChange} maxLength="150" />
            <div className="withdep-fee">
              <div>
                <div
                  style={underMinimum ? { color: 'rgb(255, 82, 117)'} : null}
                >
                  Minimum:
                  &nbsp;
                  <span
                    className="num"
                  >
                    {transMin ? Number(transMin) : Number(0)} {asset}
                  </span>
                </div>
                <div
                  style={overMaximum ? { color: 'rgb(255, 82, 117)'} : null}
                >
                  Available:
                  &nbsp;
                  <span
                    className="num"
                  >
                    {assetNet ? Number(assetNet) : Number(0)} {asset}
                  </span>
                </div>
              </div>
              <div>
                <div>
                  Fee: <span className="num">
                    {transFee ? Number(transFee) : Number(0)} {asset}
                  </span>
                </div>
                <div>
                  Daily Limit: <span className="num">
                    {transDaily ? Number(transDaily) : Number(0)} {asset}
                  </span>
                </div>
              </div>
            </div>
            <button style={{ width: '100%' }} type="submit" className="vlt-button" disabled={!complete}>
              <span>
                Continue
              </span>
            </button>
          </div>

          <div className="cell small-12 medium-12 large-12 wd-info">
            {asset === 'ETH' && (
              <p>
                <b>
                  Withdrawing funds to a smart contract may fail. If you encounter issues sending, please make sure you&apos;re sending to a standard Ethereum contract.
                </b>
              </p>
            )}
            <p>
              <b>
                Do not withdraw directly to a crowdfund or ICO. We will not credit your account with tokens from that sale.
              </b>
            </p>
            <p>
              Only one currency can be withdrawed at a time. You can only withdraw once every 5 minutes.
            </p>
          </div>

        </div>

        {this.modalSide()}

      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  balance: state.balance.balance,
  coins: state.coins,
  withdrawFee: state.coins.withdrawFee,
  errors: state.coins.errors,
  success: state.coins.success,
  loading: state.coins.loading,
  addressLoading: state.addressbook.loading,
  addressbook: state.addressbook.addressbook,
});

export default withRouter(connect(mapStateToProps)(WithdrawModal));
